module.exports = __webpack_public_path__ + "static/media/rcms-video.9de2b1d0.mp4";